import { render, staticRenderFns } from "./CongratulationsSectionMob.vue?vue&type=template&id=47108b1a&scoped=true"
import script from "./CongratulationsSectionMob.vue?vue&type=script&lang=js"
export * from "./CongratulationsSectionMob.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsSectionMob.vue?vue&type=style&index=0&id=47108b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47108b1a",
  null
  
)

export default component.exports